import { Component, OnInit, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { filter, map, Observable, startWith } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { AppVerticalMenuComponent } from 'app/component/app-vertical-menu/app-vertical-menu.component';

@UntilDestroy()
@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
  imports: [
    CommonModule,
    RouterOutlet,
    AppHeaderComponent,
    AppVerticalMenuComponent,
  ],
})
export class FullLayoutComponent implements OnInit {
  showSidebar!: Observable<boolean>;
  layoutClass = '';

  constructor(
    private breakpointObserver: BreakpointObserver,
    private renderer2: Renderer2,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.layoutClass =
          this.getDeepestData(this.route.snapshot.root)['layout'] || '';
      });

    this.showSidebar = this.breakpointObserver
      .observe(['(min-width: 992px)'])
      .pipe(
        untilDestroyed(this),
        map((value) => {
          this.updateContentMargin();
          return value.matches;
        }),
      );
  }

  private getDeepestData(route: any): any {
    let lastChild = route;
    while (lastChild.firstChild) {
      lastChild = lastChild.firstChild;
    }
    return lastChild.data;
  }

  private updateContentMargin() {
    requestAnimationFrame(() => {
      try {
        const header = this.renderer2.selectRootElement(
          '.header__navbar',
          true,
        );
        const content = this.renderer2.selectRootElement('.main-content', true);
        if (header && content) {
          content.style.marginBottom = `${header.offsetHeight}px`;
        }
      } catch (e) {
        console.log(e);
      }
    });
  }
}
